export default __webpack_public_path__ + "static/media/ic-transferencia.df0c78c5.svg";